import "./index.css";
import React from "react";

export default function ImagePlaceholder({ text, bg = true }) {
  return (
    <div
      className="image-placeholder"
      style={{ backgroundColor: bg ? "rgba(0, 0, 0, 0.1)" : null }}
    >
      <svg
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="image-placeholder__icon"
      >
        <path
          d="M178.125 25H21.875C19.3886 25 17.004 25.9877 15.2459 27.7459C13.4877 29.504 12.5 31.8886 12.5 34.375V165.625C12.5 168.111 13.4877 170.496 15.2459 172.254C17.004 174.012 19.3886 175 21.875 175H178.125C180.611 175 182.996 174.012 184.754 172.254C186.512 170.496 187.5 168.111 187.5 165.625V34.375C187.5 31.8886 186.512 29.504 184.754 27.7459C182.996 25.9877 180.611 25 178.125 25ZM129.539 50.0781C133.377 49.7264 137.231 50.5662 140.575 52.4831C143.919 54.4001 146.591 57.301 148.227 60.791C149.863 64.2809 150.384 68.1903 149.718 71.9869C149.053 75.7834 147.234 79.2827 144.508 82.0082C141.783 84.7337 138.283 86.553 134.487 87.2184C130.69 87.8838 126.781 87.363 123.291 85.7269C119.801 84.0908 116.9 81.4188 114.983 78.0749C113.066 74.7309 112.226 70.8774 112.578 67.0391C112.978 62.6756 114.893 58.59 117.992 55.4917C121.09 52.3933 125.176 50.4779 129.539 50.0781ZM29.6875 162.5C28.4443 162.5 27.252 162.006 26.3729 161.127C25.4939 160.248 25 159.056 25 157.812V123.582L75.25 78.9062L113.121 116.699L67.332 162.5H29.6875ZM175 157.812C175 159.056 174.506 160.248 173.627 161.127C172.748 162.006 171.556 162.5 170.312 162.5H85.0117L143.422 104.09L175 130.406V157.812Z"
          fill="#495057"
        />
      </svg>
      <p className="image-placeholder__text">{text}</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ImagePlaceholder/index.js